import Vue from 'vue'
import {dateFormat} from './date'

Vue.filter('json', (val) => {
    return JSON.stringify(val)
})

Vue.filter('apiState', (val) => {
    switch (val) {
        case 0:
            return 'Not Submitted'
        case 1:
            return 'Pending'
        case 2:
            return 'Completed'
        case 3:
            return 'Error'
        case 4:
            return 'Cancelled'
        default:
            return 'Unknown'
    }
})
Vue.filter('resultType', (val) => {
    switch (val) {
        case 0:
            return 'No Result'
        case 2:
            return 'No Previous Convictions'
        case 3:
            return 'SAPS Verification Required'
        case 4:
            return 'Pending SAPS Verification'
        default:
            return 'Unknown'
    }
})
Vue.filter('serviceType', (val) => {
    switch (val) {
        case 0:
            return 'Standard'
        case 1:
            return 'Premium'
        case 2:
            return 'Priority'
        default:
            return 'Unknown'
    }
})
    

Vue.filter('date', (val, format) => {
    if (typeof(val) == 'string') {
        // try to parse date iso8601
        val = new Date(val)
    }
    if (val instanceof Date) {
        return dateFormat(val, format || '%d %M %Y')
    }

    return ''
})

Vue.filter('datetime', (val, format) => {
    if (typeof(val) == 'string') {
        // try to parse date iso8601
        val = new Date(val)
    }
    if (val instanceof Date) {
        return dateFormat(val, format || '%d %M %Y %H:%i:%s')
    }

    return ''
})


Vue.filter('filename', (fileName, maxLength = 16) => {
    let p = fileName.lastIndexOf('.')
    // cater for no extension
    if (p === -1 && fileName.length > maxLength) {
        return fileName.substring(0, maxLength - 3) + '...'
    }
    let extLength = fileName.length - p
    if (fileName.length > maxLength) {
        return `${fileName.substring(0, maxLength - extLength - 2)}...${fileName.substr(p + 1, extLength -1)}`
    }
    return fileName
})


function padd(v) {
    var str = v.toString()
    if (str.length <= 1) {
        return '0' + str
    }
    return str
}

Vue.filter('time', seconds => {
    if (seconds <= 0 ) {
        return 'none'
    }
    var mins = Math.floor(seconds / 60)
    var sec = seconds % 60
    return `${padd(mins)}:${padd(sec)}`
})

Vue.filter('length', val => {
    if (!val) {
        return 0
    }
    if (typeof val == 'string') {
        return val.length
    }
    return 'NA'
})

Vue.filter('truncate', (val, length = 10) => {
    if (!val || val.length < length) {
        return val
    }
    return val.substring(0, length)
})


const statusText = ['Pending', 'Error', 'Cancelled', 'Completed', 'Failed', 'Not Found']

Vue.filter('enquiryStatus', val => {
    return statusText[val] || 'Unknown'
})

const docStatus =  ['Pending', 'Error', 'Cancelled', 'Completed']

Vue.filter('documentstatus', val => {
    return docStatus[val] || 'Unknown'
})

Vue.filter('resultStatus', val => {
    return ['None', 'Single', 'Multiple', 'No Result'][val]
})

Vue.filter('actiontype', val => {
    return ['Absconded','Bad Debt Written Off','Final Notice','Handed Over','Return To Drawer Check','Repossession','Insurance Commissions'][val]
})

Vue.filter('naEmpty', val => {
    if (!val || val.length == 0) {
        return 'N/A'
    }
    return val
})


const resultStatus =  ['N/A', 'Yes', 'No']
Vue.filter('result', val => {
    return resultStatus[val] || 'Unknown'
})

const deedOffices = [
    'NotSpecified',
    'Bloemfontein',
    'CapeTown',
    'Johannesburg',
    'Kimberley',
    'KingWilliamsTown',
    'Mpumalanga',
    'Pietermaritzburg',
    'Pretoria',
    'Umtata',
    'Vryburg',
    'Limpopo',
]
Vue.filter('deedOffice', val => {
    return deedOffices[val]
})

const provinces = [
    'Eastern Cape',
    'FreeState',
    'Gauteng',
    'KwaZuluNatal',
    'Limpopo',
    'Mpumalanga',
    'NorthWest',
    'Northern Cape',
    'Western Cape',
    'Unknown'
]
Vue.filter('province', val => {
    return provinces[val]
})

Vue.filter('yesno', val => {
    return val ? 'Yes' : 'No'
})

Vue.filter('autotype', val => {
    return val ? 'Previous' : 'Current'
})

Vue.filter('assettype', val => {
    return val ? 'Company' : 'Consumer'
})

Vue.filter('arraysplit', (val, split = '\n') => {
    if (val == null) {
        return val
    }

    return val.filter(l => l != null).join(split)
})

const bytesScale = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

Vue.filter('bytes', val => {
    if (Number.isNaN(val)) {
        return 'N/A'
    }
    if (typeof val != 'number') {
        val = parseInt(val)
    }
    // Val is in bytes
    for (var scale of bytesScale) {
        if (val < 1024) {
            return Math.floor(val) + ' ' + scale
        }
        val /= 1024
    }
    return Math.floor(val) + ' ' + bytesScale[bytesScale.length - 1]
})

Vue.filter('round', val => {
    if (typeof val != 'number')  {
        return val;
    }
    return val.toFixed(2);
})

Vue.filter('currency', val => {
    if (Number.isNaN(val)) {
        return 'N/A'
    }
    if (typeof val != 'number') {
        val = parseInt(val)
    }
    return 'R ' + val.toFixed(2)
})

Vue.filter('thousand_separator', val => {
    if (val === undefined || val === '' || val == null || Number.isNaN(val)) return val

    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})
